import Tools from "@/utils/Tools"
export type Method =
    | 'get' | 'GET'
    | 'delete' | 'DELETE'
    | 'head' | 'HEAD'
    | 'options' | 'OPTIONS'
    | 'post' | 'POST'
    | 'put' | 'PUT'
    | 'patch' | 'PATCH'
    | 'purge' | 'PURGE'
    | 'link' | 'LINK'
    | 'unlink' | 'UNLINK';

export function request<T>(input: {
    url: string,
    method: Method,
    headers?: Record<string, any>,
    params?: Record<string, any>
    data?: Record<string, any>
}) {
    switch (input.method) {
        case "GET":
        case "get":
        case "delete":
        case "DELETE":
            input.data = input.params;
            break;
        default:
            if (input.params) {
                if (Object.keys(input.params).length > 0) {
                    if (input.url.indexOf('?') == -1)
                        input.url += '?';
                    for (const key in input.params) {
                        input.url += `${key}=${encodeURIComponent(input.params[key])}&`;
                    }
                    if (input.url.endsWith('&'))
                        input.url = input.url.substring(0, input.url.length - 1);
                }
            }
            break;
    }


    //#region 解码Header
    // headers: {
    // 'Content-Type': 'multipart/form-data'
    // },
    //#endregion
    let contentType = "application/json";
    if(input.headers){
        const _contentType = input.headers['Content-Type'] as string;
        if(_contentType)
            contentType = _contentType;
    }
    

    return Tools.FetchAsync<T>(
        input.url,
        input.data,
        input.method,
        contentType as any
    );
};